/**
 * Formate une durée en secondes en format lisible (heures, minutes, secondes)
 * @param {number} seconds - Durée en secondes
 * @returns {string} - Durée formatée (ex: "1h 30min", "45min", "30s")
 */
export const formatDuration = (seconds) => {
    if (!seconds || seconds === 0) return '0s';
    
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    const parts = [];
    
    if (hours > 0) {
        parts.push(`${hours}h`);
    }
    
    if (minutes > 0) {
        parts.push(`${minutes}min`);
    }
    
    // Afficher les secondes seulement si < 1 minute
    if (hours === 0 && minutes === 0 && secs > 0) {
        parts.push(`${secs}s`);
    }
    
    return parts.join(' ') || '0s';
};

